(function () {

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}
function $14f878af2f96d88a$export$71511d61b312f219(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}


function $a1751332bdbcd2df$export$71511d61b312f219(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}


var $287db0316ca2c5f6$export$2e2bcd8739ae039 = function Toaster() {
    "use strict";
    var _this = this;
    (0, $14f878af2f96d88a$export$71511d61b312f219)(this, Toaster);
    (0, $a1751332bdbcd2df$export$71511d61b312f219)(this, "buildContainer", function() {
        var container = document.createElement('div');
        container.classList.add('jwc-toast-container');
        document.body.appendChild(container);
        return container;
    });
    (0, $a1751332bdbcd2df$export$71511d61b312f219)(this, "toast", function(settings) {
        var toast = new $287db0316ca2c5f6$var$Toast(settings, _this);
        _this.slots.push(toast);
        toast.show();
        _this.container.appendChild(toast.element);
        return toast;
    });
    this.container = this.buildContainer();
    this.slots = [];
};
var $287db0316ca2c5f6$var$Toast = function Toast(settings, toaster) {
    "use strict";
    var _this = this;
    (0, $14f878af2f96d88a$export$71511d61b312f219)(this, Toast);
    (0, $a1751332bdbcd2df$export$71511d61b312f219)(this, "buildToast", function() {
        var toast = document.createElement('div');
        toast.classList.add('jwc-toast', "jwc-toast-".concat(_this.type));
        _this.element = toast;
        _this.buildIcon();
        _this.buildBody();
        _this.buildContent();
        _this.buildCloser();
    });
    (0, $a1751332bdbcd2df$export$71511d61b312f219)(this, "buildIcon", function() {
        var icon = document.createElement('div');
        icon.classList.add('jwc-toast-icon');
        icon.innerHTML = _this.getTypeIcon(_this.type);
        _this.icon = icon;
        _this.element.appendChild(_this.icon);
    });
    (0, $a1751332bdbcd2df$export$71511d61b312f219)(this, "buildBody", function() {
        var body = document.createElement('div');
        body.classList.add('jwc-toast-body');
        _this.body = body;
        _this.element.appendChild(_this.body);
    });
    (0, $a1751332bdbcd2df$export$71511d61b312f219)(this, "buildContent", function() {
        if (_this.title) {
            var title = document.createElement('p');
            title.classList.add('jwc-toast-title');
            title.innerHTML = _this.title;
            _this.titleElement = title;
            _this.body.appendChild(title);
        }
        if (_this.content) {
            var content = document.createElement('p');
            content.classList.add('jwc-toast-content');
            content.innerHTML = _this.content;
            _this.contentElement = content;
            _this.body.appendChild(content);
        }
    });
    (0, $a1751332bdbcd2df$export$71511d61b312f219)(this, "buildCloser", function() {
        var closer = document.createElement('button');
        closer.classList.add('jwc-toast-closer');
        closer.innerHTML = '\n            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512" class="jwc-toast-closer-icon">\n                <path d="M310.6 150.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L160 210.7 54.6 105.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L114.7 256 9.4 361.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L160 301.3 265.4 406.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L205.3 256 310.6 150.6z"/>\n            </svg>\n        ';
        closer.addEventListener('click', _this.clear);
        _this.closerElement = closer;
        _this.element.appendChild(closer);
    });
    (0, $a1751332bdbcd2df$export$71511d61b312f219)(this, "show", function() {
        _this.element.classList.add('transition-visible');
        _this.isVisible = true;
        _this.element.addEventListener('animationend', function(e) {
            _this.element.classList.remove('transition-visible');
            _this.element.classList.add('is-visible');
        });
        if (_this.autoDismiss) setTimeout(function() {
            _this.clear();
        }, 7000);
    });
    (0, $a1751332bdbcd2df$export$71511d61b312f219)(this, "clear", function() {
        _this.element.classList.add('is-visible');
        _this.element.classList.add('transition-clear');
        _this.isVisible = false;
        _this.element.addEventListener('animationend', function(e) {
            _this.element.parentElement.removeChild(_this.element);
            _this.toaster.slots = _this.toaster.slots.filter(function(slot) {
                return slot.id !== _this.id;
            });
        });
    });
    (0, $a1751332bdbcd2df$export$71511d61b312f219)(this, "getTypeIcon", function(type) {
        var icon = '';
        switch(type){
            case 'success':
                icon = '\n                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">\n                        <path d="M470.6 105.4c12.5 12.5 12.5 32.8 0 45.3l-256 256c-12.5 12.5-32.8 12.5-45.3 0l-128-128c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L192 338.7 425.4 105.4c12.5-12.5 32.8-12.5 45.3 0z"/>\n                    </svg>';
                break;
            case 'warning':
                icon = '\n                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">\n                        <path d="M256 0C114.6 0 0 114.6 0 256s114.6 256 256 256s256-114.6 256-256S397.4 0 256 0zM256 464c-114.7 0-208-93.31-208-208S141.3 48 256 48s208 93.31 208 208S370.7 464 256 464zM256 304c13.25 0 24-10.75 24-24v-128C280 138.8 269.3 128 256 128S232 138.8 232 152v128C232 293.3 242.8 304 256 304zM256 337.1c-17.36 0-31.44 14.08-31.44 31.44C224.6 385.9 238.6 400 256 400s31.44-14.08 31.44-31.44C287.4 351.2 273.4 337.1 256 337.1z"/>\n                    </svg>';
                break;
            case 'favorite':
                icon = '\n                    <svg width="21" height="16" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 21 16" aria-hidden="true" focusable="false">\n                        <g><path d="M14.64 5c.263 0 .504.15.618.387l1.381 2.842 3.087.455a.689.689 0 0 1 .382 1.169l-2.238 2.215.53 3.13a.691.691 0 0 1-1.003.721l-2.756-1.471-2.756 1.471a.69.69 0 0 1-1.003-.722l.528-3.13-2.238-2.214a.686.686 0 0 1 .382-1.169l3.085-.455 1.381-2.842A.688.688 0 0 1 14.64 5ZM2.25 10c.416 0 .75.334.75.75v1.5c0 .416-.334.75-.75.75H.75a.748.748 0 0 1-.75-.75v-1.5c0-.416.334-.75.75-.75h1.5Z"/><path d="m8.075 10.5 2.022 2H5.5a.999.999 0 0 1-.993-.883L4.5 11.5c0-.553.447-1 1-1h2.575ZM2.25 5c.416 0 .75.334.75.75v1.5c0 .416-.334.75-.75.75H.75A.748.748 0 0 1 0 7.25v-1.5C0 5.334.334 5 .75 5h1.5Zm10.585.5-.924 1.903-.664.097H5.5a.999.999 0 0 1-.993-.883L4.5 6.5c0-.553.447-1 1-1h7.335ZM2.25 0c.416 0 .75.334.75.75v1.5c0 .416-.334.75-.75.75H.75A.748.748 0 0 1 0 2.25V.75C0 .334.334 0 .75 0h1.5ZM14.5.5a.999.999 0 1 1 0 2h-9a.999.999 0 1 1 0-2h9Z"/></g>\n                    </svg>';
                break;
        }
        return icon;
    });
    this.type = settings.type;
    this.title = settings.title;
    this.autoDismiss = settings.hasOwnProperty('autoDismiss') ? settings.autoDismiss : true;
    this.content = settings.content;
    this.id = Date.now() + toaster.slots.length;
    this.toaster = toaster;
    this.buildToast();
};


var $62682efe9afeb191$export$d07517a676ce386f = {
    xxs: 320,
    xs: 450,
    sm: 680,
    md: 768,
    lg: 992,
    xl: 1170,
    xxl: 1440,
    xxxl: 1920,
    super: 2400
};
var $62682efe9afeb191$export$f68cee56cc062164 = {
    'xxs': window.matchMedia("(min-width: ".concat($62682efe9afeb191$export$d07517a676ce386f.xxs, "px)")),
    'xs': window.matchMedia("(min-width: ".concat($62682efe9afeb191$export$d07517a676ce386f.xs, "px)")),
    'sm': window.matchMedia("(min-width: ".concat($62682efe9afeb191$export$d07517a676ce386f.sm, "px)")),
    'md': window.matchMedia("(min-width: ".concat($62682efe9afeb191$export$d07517a676ce386f.md, "px)")),
    'lg': window.matchMedia("(min-width: ".concat($62682efe9afeb191$export$d07517a676ce386f.lg, "px)")),
    'xl': window.matchMedia("(min-width: ".concat($62682efe9afeb191$export$d07517a676ce386f.xl, "px)")),
    'xxl': window.matchMedia("(min-width: ".concat($62682efe9afeb191$export$d07517a676ce386f.xxl, "px)")),
    'xxxl': window.matchMedia("(min-width: ".concat($62682efe9afeb191$export$d07517a676ce386f.xxxl, "px)")),
    'super': window.matchMedia("(min-width: ".concat($62682efe9afeb191$export$d07517a676ce386f.super, "px)")),
    'xxs-max': window.matchMedia("(max-width: ".concat($62682efe9afeb191$export$d07517a676ce386f.xxs - 1, "px)")),
    'xs-max': window.matchMedia("(max-width: ".concat($62682efe9afeb191$export$d07517a676ce386f.xs - 1, "px)")),
    'sm-max': window.matchMedia("(max-width: ".concat($62682efe9afeb191$export$d07517a676ce386f.sm - 1, "px)")),
    'md-max': window.matchMedia("(max-width: ".concat($62682efe9afeb191$export$d07517a676ce386f.md - 1, "px)")),
    'lg-max': window.matchMedia("(max-width: ".concat($62682efe9afeb191$export$d07517a676ce386f.lg - 1, "px)")),
    'xl-max': window.matchMedia("(max-width: ".concat($62682efe9afeb191$export$d07517a676ce386f.xl - 1, "px)")),
    'xxl-max': window.matchMedia("(max-width: ".concat($62682efe9afeb191$export$d07517a676ce386f.xxl - 1, "px)")),
    'xxxl-max': window.matchMedia("(max-width: ".concat($62682efe9afeb191$export$d07517a676ce386f.xxxl - 1, "px)")),
    'super-max': window.matchMedia("(max-width: ".concat($62682efe9afeb191$export$d07517a676ce386f.super - 1, "px)"))
};
var $62682efe9afeb191$export$90086be4f76e40ba = function(size) {
    return $62682efe9afeb191$export$f68cee56cc062164[size].matches;
};
var $62682efe9afeb191$var$handlers = [];
var $62682efe9afeb191$var$callMediaQueryHandlers = function(handlers, mediaQuery, event) {
    handlers.forEach(function(handler) {
        return handler(event, mediaQuery);
    });
};
var $62682efe9afeb191$export$e79b2aded9cc7c48 = function(handler) {
    return $62682efe9afeb191$var$handlers.push(handler);
};
var $62682efe9afeb191$export$2e2bcd8739ae039 = function() {
    var _loop = function(mq) {
        if ($62682efe9afeb191$export$f68cee56cc062164.hasOwnProperty(mq)) {
            var mediaQuery = $62682efe9afeb191$export$f68cee56cc062164[mq];
            $62682efe9afeb191$var$callMediaQueryHandlers($62682efe9afeb191$var$handlers, mediaQuery);
            mediaQuery.addEventListener('change', function(e) {
                $62682efe9afeb191$var$callMediaQueryHandlers($62682efe9afeb191$var$handlers, mediaQuery, e);
            });
        }
    };
    for(var mq in $62682efe9afeb191$export$f68cee56cc062164)_loop(mq);
};



function $98bc9ed74ab4b61d$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $98bc9ed74ab4b61d$export$71511d61b312f219(Constructor, protoProps, staticProps) {
    if (protoProps) $98bc9ed74ab4b61d$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $98bc9ed74ab4b61d$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}



function $fc00a93b7c6faa38$export$71511d61b312f219(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}


function $d712737f326cfecb$export$71511d61b312f219(arr) {
    if (Array.isArray(arr)) return (0, $fc00a93b7c6faa38$export$71511d61b312f219)(arr);
}


function $b7a0f0d57f3eacb5$export$71511d61b312f219(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}


function $1cf67d305241196c$export$71511d61b312f219() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}



function $9f42406e0b1867d1$export$71511d61b312f219(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return (0, $fc00a93b7c6faa38$export$71511d61b312f219)(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return (0, $fc00a93b7c6faa38$export$71511d61b312f219)(o, minLen);
}


function $7f330cb05a0d35f2$export$71511d61b312f219(arr) {
    return (0, $d712737f326cfecb$export$71511d61b312f219)(arr) || (0, $b7a0f0d57f3eacb5$export$71511d61b312f219)(arr) || (0, $9f42406e0b1867d1$export$71511d61b312f219)(arr) || (0, $1cf67d305241196c$export$71511d61b312f219)();
}


var $ea88dda94eed7848$exports = {};
$ea88dda94eed7848$exports = [
    'a[href]:not([tabindex^="-"])',
    'area[href]:not([tabindex^="-"])',
    'input:not([type="hidden"]):not([type="radio"]):not([disabled]):not([tabindex^="-"])',
    'input[type="radio"]:not([disabled]):not([tabindex^="-"]):checked',
    'select:not([disabled]):not([tabindex^="-"])',
    'textarea:not([disabled]):not([tabindex^="-"])',
    'button:not([disabled]):not([tabindex^="-"])',
    'iframe:not([tabindex^="-"])',
    'audio[controls]:not([tabindex^="-"])',
    'video[controls]:not([tabindex^="-"])',
    '[contenteditable]:not([tabindex^="-"])',
    '[tabindex]:not([tabindex^="-"])'
];


var $5b60cdba3ee79e87$var$KEYCODE = {
    TAB: 9,
    ESCAPE: 27,
    SPACE: 32,
    LEFT: 37,
    UP: 38,
    RIGHT: 39,
    DOWN: 40
};
var $5b60cdba3ee79e87$export$2e2bcd8739ae039 = $5b60cdba3ee79e87$var$KEYCODE;


// remove only the class from the target ('data-target' attribute) of an array of elements
// remove only the targetClass from an array of elements
function $0b70dedeca18be5b$export$26459cd9e3f72c5b(elementsArray, targetClass) {
    if (!Array.isArray(elementsArray)) {
        console.log('Error: removeClassFromElements requires an array elements.');
        return;
    }
    elementsArray.forEach(function(element) {
        return element.classList.remove(targetClass);
    });
}
function $0b70dedeca18be5b$export$82395ffd5ba6d0b0(elementsArray, className) {
    elementsArray.forEach(function(element) {
        return $0b70dedeca18be5b$export$2562999169740ceb(element).classList.remove(className);
    });
}
function $0b70dedeca18be5b$export$760f3605e67305b6(element, className, delay) {
    element.classList.add(className);
    setTimeout(function() {
        element.classList.remove(className);
    }, delay);
}
// get the target ('data-target' attribute) of an elements
function $0b70dedeca18be5b$export$2562999169740ceb(element) {
    var targetID = element.dataset.target;
    return document.getElementById(targetID);
}
function $0b70dedeca18be5b$export$f883456a56996078(element) {
    element.parentNode.removeChild(element);
}
function $0b70dedeca18be5b$export$180942c27b4557d9(element, overlayClass) {
    var overlayElement = document.createElement('div');
    overlayClass = overlayClass || 'page__overlay';
    overlayElement.classList.add(overlayClass);
    element.insertAdjacentElement('beforebegin', overlayElement);
    return overlayElement;
}
function $0b70dedeca18be5b$export$795910f5f15a9633(element) {
    return function(element) {
        return element.offsetWidth || element.offsetHeight || element.getClientRects().length;
    };
}
var $0b70dedeca18be5b$export$4385e60b38654f68 = function(min, max) {
    return Math.floor(Math.random() * (max - min)) + min;
};
function $0b70dedeca18be5b$export$8574ae8ebb50c7a(value) {
    var includeSymbol = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true, includeCents = arguments.length > 2 ? arguments[2] : void 0;
    var formatter = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD'
    });
    var parts = formatter.formatToParts(value);
    var formattedInteger = parts.map(function(part) {
        return part.type === 'integer' || part.type === 'group' ? part.value : '';
    }).join('');
    var symbol = includeSymbol ? parts[0].value : '';
    var cents = includeCents ? ". ".concat(parts[parts.length - 1]) : '';
    return "".concat(symbol).concat(formattedInteger).concat(cents);
}
var $0b70dedeca18be5b$export$f3f6a3b03489b8a7 = function(value) {
    if (value === 0) return value;
    // shorthand label
    var labels = [
        '',
        'k',
        'm',
        'b',
        't'
    ];
    // dividing the value by 3.
    var sNum = ('' + value).length / 3;
    if (sNum % 2 === 0) return ('' + value).slice(0, 3) + labels[1];
    if (sNum < 2) return ('' + value).slice(0, 2) + labels[1];
    sNum = Math.floor(sNum);
    // calculating the precised value.
    var sVal = parseFloat((sNum != 0 ? value / Math.pow(1000, sNum) : value).toPrecision(2));
    sVal = sVal.toFixed(1);
    // appending the letter to precised val.
    return sVal + labels[sNum];
};
var $0b70dedeca18be5b$export$e9f8fcacef3bca4b = function(word) {
    return word[0].toUpperCase() + word.slice(1);
};



var $6b54219027cf0c7e$var$checkForMobileSafari = function() {
    return /iP(ad|hone|od).+Version\/[\d\.]+.*Safari/i.test(navigator.userAgent);
};
var $6b54219027cf0c7e$export$c496025585f0ffcf = $6b54219027cf0c7e$var$checkForMobileSafari();


var $442389f82da6694f$var$allowScrollElement;
var $442389f82da6694f$var$allowScrollElementChildren;
var $442389f82da6694f$export$e72d08e9050a4a3e = function(element) {
    if (!(0, $6b54219027cf0c7e$export$c496025585f0ffcf)) {
        document.body.classList.add('no-scroll');
        return;
    }
    if (!element) {
        window.addEventListener('touchmove', function(e) {
            return e.preventDefault();
        });
        return;
    }
    $442389f82da6694f$var$allowScrollElement = element;
    $442389f82da6694f$var$allowScrollElementChildren = (0, $7f330cb05a0d35f2$export$71511d61b312f219)($442389f82da6694f$var$allowScrollElement.querySelectorAll('*'));
    window.addEventListener('touchmove', $442389f82da6694f$var$handleTouchMove, {
        passive: false
    });
    window.addEventListener('scroll', $442389f82da6694f$var$handleTouchMove, {
        passive: false
    });
};
var $442389f82da6694f$export$dea89f0ae86a92c6 = function(element) {
    if (!(0, $6b54219027cf0c7e$export$c496025585f0ffcf)) {
        document.body.classList.remove('no-scroll');
        return;
    }
    if (!element) {
        window.removeEventListener('touchmove', function(e) {
            return e.preventDefault();
        });
        return;
    }
    window.removeEventListener('touchmove', $442389f82da6694f$var$handleTouchMove, {
        passive: false
    });
    window.removeEventListener('scroll', $442389f82da6694f$var$handleTouchMove, {
        passive: false
    });
};
var $442389f82da6694f$var$handleTouchMove = function(e) {
    var isTargetElement = e.target === $442389f82da6694f$var$allowScrollElement;
    var isTargetElementChild = $442389f82da6694f$var$allowScrollElementChildren.includes(e.target);
    if (!isTargetElement || !isTargetElementChild) e.preventDefault();
};


var $c69b09cc0cfb1962$var$modals = [];
var $c69b09cc0cfb1962$var$modalOpeners;
var $c69b09cc0cfb1962$export$2b77a92f1a5ad772 = /*#__PURE__*/ function() {
    "use strict";
    function Modal(element) {
        var _this = this;
        var opener = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null, settings = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
        (0, $14f878af2f96d88a$export$71511d61b312f219)(this, Modal);
        (0, $a1751332bdbcd2df$export$71511d61b312f219)(this, "hide", function(e) {
            _this.isShown = false;
            _this.modalBody.style.setProperty('--modal-body-height', "".concat(_this.modalBody.offsetHeight, "px"));
            _this.modal.dataset.modalState = 'closing';
            _this.modal.removeAttribute('open');
            if (_this.hasAnimation(_this.modalContent)) _this.modal.addEventListener('animationend', function() {
                _this.setClosedProperties();
            }, {
                once: true
            });
            else _this.setClosedProperties();
            document.removeEventListener('keydown', _this._keyDownHandler);
            document.body.removeEventListener('focus', _this.maintainFocus, true);
            if (_this.adjustable) _this.removePointerEvents();
            if (_this.autoOpenMaxCount) sessionStorage.setItem(_this.sessionStorageClosedKey, true);
            if (_this.bodyCloser) document.removeEventListener('click', _this.documentBodyClickHandler, true);
            if (_this.previouslyFocused && _this.previouslyFocused.focus) {
                _this.previouslyFocused.focus();
                _this.previouslyFocused.classList.remove('target-open');
            }
            if (_this.lockBodyScroll) (0, $442389f82da6694f$export$dea89f0ae86a92c6)(_this.modal);
            if (_this.hideCallback && typeof _this.hideCallback === 'function') _this.hideCallback(_this.modal);
        });
        (0, $a1751332bdbcd2df$export$71511d61b312f219)(this, "minimize", function(e) {
            _this.modal.dataset.modalState = 'minimized';
        });
        (0, $a1751332bdbcd2df$export$71511d61b312f219)(this, "maximize", function(e) {
            _this.modal.dataset.modalState = 'maximized';
        });
        (0, $a1751332bdbcd2df$export$71511d61b312f219)(this, "adjust", function(e) {
            if (!_this.adjustable) return;
            var ajustmentPosition = _this.modal.dataset.modalState;
            if (ajustmentPosition === 'collapsed' || ajustmentPosition === 'minimized') {
                _this.maximize();
                return;
            }
            if (ajustmentPosition === 'maximized') {
                _this.minimize();
                return;
            }
        });
        (0, $a1751332bdbcd2df$export$71511d61b312f219)(this, "documentBodyClickHandler", function(e) {
            if (!e.target.closest('[aria-modal=true]') && e.target !== _this.previouslyFocused) _this.hide();
        });
        (0, $a1751332bdbcd2df$export$71511d61b312f219)(this, "pointerDownHanlder", function(e) {
            _this.currentModalState = _this.modal.dataset.modalState;
            _this.moveFocusIn();
            if (_this.currentModalState !== 'collapsed' && _this.currentModalState !== 'minimized' && !e.target.closest('.jwc-modal-header')) return;
            if (e.target.closest('[data-modal-closer]')) {
                _this.hide(e);
                return;
            }
            if (e.target.closest('[data-modal-minimizer]') || e.target.closest('[data-modal-maximizer]')) {
                _this.adjust(e);
                return;
            }
            e.preventDefault();
            _this.currentModalState = _this.modal.dataset.modalState;
            _this.currentBodyHeight = _this.modalBody.getBoundingClientRect().height;
            _this.currentModalBottom = _this.modalContent.getBoundingClientRect().bottom;
            _this.currentYPos = e.clientY;
            _this.pointerActive = true;
            _this.modalContent.setPointerCapture(e.pointerId);
            _this.modalContent.addEventListener('pointermove', _this.pointerMoveHandler);
            _this.modalContent.addEventListener('pointerup', _this.pointerUpHandler);
            _this.modalContent.addEventListener('pointercancel', _this.pointerUpHandler);
        });
        (0, $a1751332bdbcd2df$export$71511d61b312f219)(this, "pointerUpHandler", function(e) {
            if (!_this.pointerActive) return;
            var maxHeightNumber = parseInt(_this.maxHeight.split('vh'));
            var maxHeightPixels = window.innerHeight / 100 * maxHeightNumber;
            var pixelsToBottom = _this.currentModalBottom - e.clientY;
            _this.modalBody.style.height = null;
            _this.modalContent.style.transform = null;
            _this.modalBody.style.setProperty('--modal-body-height', null);
            if (pixelsToBottom <= 0) _this.hide();
            else if (pixelsToBottom < 100) _this.modal.dataset.modalState = 'collapsed';
            else if (pixelsToBottom < maxHeightPixels * 0.3) _this.modal.dataset.modalState = 'minimized';
            else if (pixelsToBottom < maxHeightPixels * 0.75) _this.modal.dataset.modalState = 'tiled';
            else _this.modal.dataset.modalState = 'maximized';
            _this.pointerActive = false;
            _this.currentBodyHeight = null;
            _this.currentModalBottom = null;
            _this.currentYPos = 0;
            _this.modalContent.removeEventListener('pointermove', _this.pointerMoveHandler);
            _this.modalContent.removeEventListener('pointerup', _this.pointerUpHandler);
            _this.modalContent.removeEventListener('pointercancel', _this.pointerUpHandler);
        });
        (0, $a1751332bdbcd2df$export$71511d61b312f219)(this, "pointerMoveHandler", function(e) {
            if (!_this.pointerActive) return;
            if (e.clientY > _this.currentModalBottom) {
                _this.hide();
                return;
            }
            var delta = e.clientY - _this.currentYPos;
            var adjustedHeight = _this.currentBodyHeight - delta > 0 ? _this.currentBodyHeight - delta : 0;
            _this.modal.dataset.modalState = 'adjusting';
            _this.modalBody.style.setProperty('--modal-body-height', "".concat(adjustedHeight, "px"));
        });
        (0, $a1751332bdbcd2df$export$71511d61b312f219)(this, "keyDownHandler", function(e) {
            if (e.keyCode === (0, $5b60cdba3ee79e87$export$2e2bcd8739ae039).ESCAPE) _this.hide();
            else if (e.keyCode === (0, $5b60cdba3ee79e87$export$2e2bcd8739ae039).TAB) $c69b09cc0cfb1962$var$trapFocus(_this.modal, e);
        });
        this.modal = element;
        this.modalContent = this.modal.querySelector('.jwc-modal-content');
        this.modalHeader = this.modal.querySelector('.jwc-modal-header');
        this.modalBody = this.modal.querySelector('.jwc-modal-body');
        this.adjustable = this.modal.hasAttribute('data-modal-adjustable');
        this.controllers = this.getModalControllers();
        this.showCallback = settings.showCallback || null;
        this.hideCallback = settings.hideCallback || null;
        this.modal.setAttribute('hidden', true);
        this.modal.setAttribute('role', 'dialog');
        this.modal.setAttribute('aria-modal', true);
        this.initialOpenState = this.modal.dataset.modalInitialOpenState;
        this.maxHeight = this.modal.dataset.modalMaxHeight;
        this.show = this.show.bind(this);
        this.hide = this.hide.bind(this);
        this.maintainFocus = this.maintainFocus.bind(this);
        this.keyDownHandler = this.keyDownHandler.bind(this);
        this.bodyCloser = this.modal.hasAttribute('data-body-closer');
        this.lockBodyScroll = this.modal.hasAttribute('data-lock-body-scroll') ? this.modal.dataset.lockBodyScroll : false;
        this.addControllerEvents();
        this.autoOpener = settings.autoOpen;
        this.autoOpenMaxCount = this.autoOpener ? this.modal.dataset.modalAutoOpen : null;
        this.opener = opener;
        this.sessionStorageClosedKey = "".concat(this.modal.id, "-closed");
        if (this.autoOpener && !this.autoOpenMaxCount) {
            if (this.getModalClosedSession()) return;
            this.show();
        }
        if (this.autoOpener && this.autoOpenMaxCount) {
            this.autoOpenMaxCount = parseInt(this.autoOpenMaxCount);
            this.localStorageOpenCountKey = "".concat(this.modal.id, "-open-count");
            this.autoOpenController();
        }
    }
    (0, $98bc9ed74ab4b61d$export$71511d61b312f219)(Modal, [
        {
            key: "show",
            value: function show(e) {
                var _this = this;
                if (!this.autoOpener && this.opener) e.preventDefault();
                if (this.showCallback && typeof this.showCallback === 'function') this.showCallback(this.modal);
                if (this.isShown) return;
                this.isShown = true;
                this.modal.removeAttribute('hidden');
                if (this.previouslyFocused) this.previouslyFocused.classList.remove('target-open');
                this.previouslyFocused = this.opener || document.activeElement;
                this.previouslyFocused.classList.add('target-open');
                this.setOpenProperties();
                if (!this.modal.hasAttribute('open')) {
                    this.modal.setAttribute('open', '');
                    this.modalContent.style.opacity = 0;
                    // Settime out used to fix Safari modal content jumping from hidden to open
                    setTimeout(function() {
                        _this.modalContent.style.opacity = 1;
                        _this.modal.dataset.modalState = 'opening';
                        if (_this.hasAnimation(_this.modalContent)) _this.modal.addEventListener('animationend', function() {
                            _this.modal.dataset.modalState = _this.initialOpenState;
                        }, {
                            once: true
                        });
                        else _this.modal.dataset.modalState = _this.initialOpenState;
                    }, 1);
                }
                this.moveFocusIn();
                document.addEventListener('keydown', this.keyDownHandler);
                document.body.addEventListener('focus', this.maintainFocus, true);
                if (this.adjustable) this.addPointerEvents();
                if (this.lockBodyScroll) (0, $442389f82da6694f$export$e72d08e9050a4a3e)(this.modal);
                if (this.bodyCloser) document.addEventListener('click', this.documentBodyClickHandler, true);
            }
        },
        {
            key: "autoOpenController",
            value: function autoOpenController() {
                if (this.getModalClosedSession()) return;
                var storedAutoOpenCount = this.getAutoOpenStoredCount() ? parseInt(this.getAutoOpenStoredCount()) : null;
                if (!storedAutoOpenCount) {
                    this.show();
                    this.setAutoOpenStoredCount(1);
                    return;
                }
                if (storedAutoOpenCount < this.autoOpenMaxCount) {
                    this.show();
                    this.setAutoOpenStoredCount(storedAutoOpenCount + 1);
                }
            }
        },
        {
            key: "getModalControllers",
            value: function getModalControllers() {
                if (!this.adjustable) return this.getModalClosers();
                return (0, $7f330cb05a0d35f2$export$71511d61b312f219)(this.getModalClosers()).concat((0, $7f330cb05a0d35f2$export$71511d61b312f219)(this.getModalAdjusters()));
            }
        },
        {
            key: "getModalClosers",
            value: function getModalClosers() {
                var innerClosers = (0, $7f330cb05a0d35f2$export$71511d61b312f219)(this.modal.querySelectorAll('[data-modal-closer]'));
                var nextSibling = this.modal.nextElementSibling;
                var adjacentCloser = [];
                if (nextSibling && nextSibling.hasAttribute('data-modal-closer')) adjacentCloser = [
                    nextSibling
                ];
                return (0, $7f330cb05a0d35f2$export$71511d61b312f219)(innerClosers).concat((0, $7f330cb05a0d35f2$export$71511d61b312f219)(adjacentCloser));
            }
        },
        {
            key: "getModalAdjusters",
            value: function getModalAdjusters() {
                return (0, $7f330cb05a0d35f2$export$71511d61b312f219)(this.modal.querySelectorAll('[data-modal-minimizer], [data-modal-maximizer]'));
            }
        },
        {
            key: "getAutoOpenStoredCount",
            value: function getAutoOpenStoredCount() {
                return localStorage.getItem(this.localStorageOpenCountKey);
            }
        },
        {
            key: "getModalClosedSession",
            value: function getModalClosedSession() {
                return sessionStorage.getItem(this.sessionStorageClosedKey);
            }
        },
        {
            key: "setOpenProperties",
            value: function setOpenProperties() {
                var peekElements = (0, $7f330cb05a0d35f2$export$71511d61b312f219)(this.modal.querySelectorAll('[data-modal-peek-amount]'));
                var peekElement = peekElements.find(function(peekElement) {
                    return getComputedStyle(peekElement)['display'] !== 'none';
                });
                var peekAmount = 0;
                if (peekElement) peekAmount = parseInt(peekElement.dataset.modalPeekAmount) + peekElement.offsetTop - this.modalHeader.offsetHeight - this.modalHeader.offsetTop;
                this.modal.style.setProperty('--maximized-body-height', '100vh');
                this.modal.style.setProperty('--tiled-body-height', '40vh');
                this.modal.style.setProperty('--minimized-body-height', "".concat(peekAmount, "px"));
                this.modal.style.setProperty('--collapsed-body-height', 0);
                this.modal.style.setProperty('--modal-max-height', this.maxHeight);
            }
        },
        {
            key: "setClosedProperties",
            value: function setClosedProperties() {
                this.modal.dataset.modalState = 'closed';
                this.modalBody.style.setProperty('--modal-body-height', null);
                this.modal.setAttribute('hidden', '');
            }
        },
        {
            key: "setAutoOpenStoredCount",
            value: function setAutoOpenStoredCount(openCount) {
                localStorage.setItem(this.localStorageOpenCountKey, openCount);
            }
        },
        {
            key: "setModalClosedSession",
            value: function setModalClosedSession() {
                sessionStorage.setItem(this.sessionStorageClosedKey, true);
            }
        },
        {
            key: "hasAnimation",
            value: function hasAnimation(element) {
                return getComputedStyle(element, null)['animation-name'] !== 'none';
            }
        },
        {
            key: "maintainFocus",
            value: function maintainFocus(e) {
                var isInModal = e.target.closest('[aria-modal=true]');
                if (!isInModal) this.moveFocusIn();
            }
        },
        {
            key: "moveFocusIn",
            value: function moveFocusIn() {
                var focusTarget = this.modal.querySelector('[autofocus]') || $c69b09cc0cfb1962$var$getFocusableChildren(this.modal)[0];
                if (!focusTarget) this.closers[0].focus();
                focusTarget.focus();
            }
        },
        {
            key: "addControllerEvents",
            value: function addControllerEvents() {
                var _this = this;
                if (!this.adjustable) {
                    this.controllers.forEach(function(closer) {
                        return closer.addEventListener('click', _this.hide);
                    });
                    return;
                }
                this.controllers.forEach(function(controller) {
                    if (_this.adjustable && controller.closest('.jwc-modal-header')) return;
                    if (controller.hasAttribute('data-modal-closer')) {
                        controller.addEventListener('click', _this.hide);
                        return;
                    }
                    if (controller.hasAttribute('data-modal-minizer')) {
                        controller.addEventListener('click', _this.adjust);
                        return;
                    }
                    if (controller.hasAttribute('data-modal-maximizer')) {
                        controller.addEventListener('click', _this.adjust);
                        return;
                    }
                });
            }
        },
        {
            key: "addPointerEvents",
            value: function addPointerEvents() {
                this.pointerActive = false;
                this.currentModalState;
                this.currentBodyHeight;
                this.currentModalBottom;
                this.currentYPos = 0;
                this.modalContent.addEventListener('pointerdown', this.pointerDownHanlder);
            }
        },
        {
            key: "removePointerEvents",
            value: function removePointerEvents() {
                this.modalContent.removeEventListener('pointerdown', this.pointerDownHanlder);
                this.modalContent.addEventListener('pointermove', this.pointerMoveHandler);
                this.modalContent.addEventListener('pointerup', this.pointerUpHandler);
                this.modalContent.addEventListener('pointercancel', this.pointerUpHandler);
            }
        }
    ]);
    return Modal;
}();
function $c69b09cc0cfb1962$var$trapFocus(node, e) {
    var focusableChildren = $c69b09cc0cfb1962$var$getFocusableChildren(node);
    var focusedItemIndex = focusableChildren.indexOf(document.activeElement);
    var lastIndex = focusableChildren.length - 1;
    var withShift = e.shiftKey;
    if (withShift && focusedItemIndex === 0) {
        focusableChildren[lastIndex].focus();
        e.preventDefault();
    } else if (!withShift && focusedItemIndex === lastIndex) {
        focusableChildren[0].focus();
        e.preventDefault();
    }
}
function $c69b09cc0cfb1962$var$getFocusableChildren(root) {
    var elements = (0, $7f330cb05a0d35f2$export$71511d61b312f219)(root.querySelectorAll((0, (/*@__PURE__*/$parcel$interopDefault($ea88dda94eed7848$exports))).join(',')));
    return elements.filter((0, $0b70dedeca18be5b$export$795910f5f15a9633));
}
var $c69b09cc0cfb1962$export$89892de00be9f648 = function(target, opener, modalSettings) {
    var defaultSettings = {
        autoOpen: false
    };
    var settings = Object.assign({}, defaultSettings, modalSettings);
    var modal = new $c69b09cc0cfb1962$export$2b77a92f1a5ad772(target, opener, settings);
    if (!settings.autoOpen && opener) opener.addEventListener("click", modal.show);
    return modal;
};
var $c69b09cc0cfb1962$export$2e2bcd8739ae039 = init = function() {
    $c69b09cc0cfb1962$var$modalOpeners = (0, $7f330cb05a0d35f2$export$71511d61b312f219)(document.querySelectorAll('[data-modal-opener], [data-modal-auto-open]'));
    if ($c69b09cc0cfb1962$var$modalOpeners.length === 0) return;
    $c69b09cc0cfb1962$var$modals = $c69b09cc0cfb1962$var$modalOpeners.map(function(modalOpener) {
        var autoOpener = modalOpener.hasAttribute("data-modal-auto-open");
        var targetId = modalOpener.dataset.target;
        var modal = autoOpener ? modalOpener : document.getElementById(targetId);
        var opener = autoOpener ? null : modalOpener;
        var settings = {
            autoOpen: autoOpener
        };
        if (!modal) {
            console.warn("Modal target not found: ", modalOpener.dataset.target);
            return;
        }
        $c69b09cc0cfb1962$export$89892de00be9f648(modal, opener, settings);
    });
};





var $90f13c4656c15d55$var$capturedElements = [];
var $90f13c4656c15d55$var$popUps = [];
var $90f13c4656c15d55$export$62cc22d0da9efd66 = function PopUp(controller) {
    "use strict";
    var _this = this;
    (0, $14f878af2f96d88a$export$71511d61b312f219)(this, PopUp);
    (0, $a1751332bdbcd2df$export$71511d61b312f219)(this, "init", function() {
        _this.controller.addEventListener('click', _this.clickHandler);
        _this.popup.addEventListener('keydown', _this.keydownHandler);
    });
    (0, $a1751332bdbcd2df$export$71511d61b312f219)(this, "open", function() {
        _this.controller.setAttribute('aria-expanded', 'true');
        _this.popup.setAttribute('data-state', 'open');
        _this.isOpened = true;
        document.body.addEventListener('click', _this.bodyClickHandler);
    });
    (0, $a1751332bdbcd2df$export$71511d61b312f219)(this, "close", function() {
        _this.controller.setAttribute('aria-expanded', 'false');
        _this.popup.setAttribute('data-state', 'closed');
        _this.isOpened = false;
        document.body.removeEventListener('click', _this.bodyClickHandler);
    });
    (0, $a1751332bdbcd2df$export$71511d61b312f219)(this, "clickHandler", function(e) {
        e.preventDefault();
        if (_this.isOpened) _this.close();
        else _this.open();
    });
    (0, $a1751332bdbcd2df$export$71511d61b312f219)(this, "bodyClickHandler", function(e) {
        var controllerClicked = e.target.closest('[aria-controls]') === _this.controller;
        var popupClicked = e.target.closest("#".concat(_this.popup.id)) === _this.popup;
        if (!controllerClicked && !popupClicked) _this.close();
    });
    (0, $a1751332bdbcd2df$export$71511d61b312f219)(this, "keydownHandler", function(e) {
        switch(e.key){
            case 'Escape':
                _this.close();
                _this.controller.focus();
        }
    });
    this.controller = controller;
    this.popup = document.getElementById(this.controller.getAttribute('aria-controls'));
    this.isOpened = false;
    this.init();
};
var $90f13c4656c15d55$export$b68b5509ce5f1141 = function(controller) {
    var popup = new $90f13c4656c15d55$export$62cc22d0da9efd66(controller);
    $90f13c4656c15d55$var$popUps.push(popup);
    return popup;
};
var $90f13c4656c15d55$export$2e2bcd8739ae039 = init = function() {
    var target = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : document;
    var targetElements = (0, $7f330cb05a0d35f2$export$71511d61b312f219)(target.querySelectorAll('button[aria-expanded][aria-controls]'));
    var dedupedTargetElements = targetElements.filter(function(targetElement) {
        return !$90f13c4656c15d55$var$capturedElements.find(function(capturedElement) {
            return targetElement === capturedElement;
        });
    });
    if (dedupedTargetElements.length === 0) return;
    dedupedTargetElements.forEach(function(element) {
        $90f13c4656c15d55$var$capturedElements.push(element);
        $90f13c4656c15d55$var$popUps.push(new $90f13c4656c15d55$export$62cc22d0da9efd66(element));
    });
};





var $84e5673159d64e64$var$headers = [];
var $84e5673159d64e64$export$71ba45104f4e8b56 = function HeaderDisclosures(header) {
    "use strict";
    var _this = this;
    (0, $14f878af2f96d88a$export$71511d61b312f219)(this, HeaderDisclosures);
    (0, $a1751332bdbcd2df$export$71511d61b312f219)(this, "init", function() {
        _this.button.addEventListener('click', _this.clickHandler);
    });
    (0, $a1751332bdbcd2df$export$71511d61b312f219)(this, "open", function() {
        _this.button.setAttribute('aria-expanded', 'true');
        _this.isOpened = true;
    });
    (0, $a1751332bdbcd2df$export$71511d61b312f219)(this, "close", function() {
        _this.button.setAttribute('aria-expanded', 'false');
        _this.isOpened = false;
    });
    (0, $a1751332bdbcd2df$export$71511d61b312f219)(this, "clickHandler", function(e) {
        e.preventDefault();
        if (_this.isOpened) _this.close();
        else _this.open();
    });
    (0, $a1751332bdbcd2df$export$71511d61b312f219)(this, "addDisclosureButton", function() {
        var chevron = '\n            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" class="jwc-header-disclosure-icon">\n                <path d="M233.4 406.6c12.5 12.5 32.8 12.5 45.3 0l192-192c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L256 338.7 86.6 169.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l192 192z"/>\n            </svg>\n        ';
        var button = document.createElement('button');
        button.setAttribute('aria-expanded', 'false');
        button.classList.add('jwc-header-disclosure');
        button.innerHTML = "\n            ".concat(_this.header.innerHTML, "\n            ").concat(chevron, "\n        ");
        _this.header.parentNode.insertBefore(button, _this.header.nextSibling);
        return button;
    });
    this.header = header;
    this.body = this.header.nextSibling;
    this.button = this.addDisclosureButton();
    this.init();
};
var $84e5673159d64e64$export$2e2bcd8739ae039 = init = function() {
    var target = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : document;
    var targetElements = (0, $7f330cb05a0d35f2$export$71511d61b312f219)(target.querySelectorAll('[data-header-disclosure]'));
    var dedupedHeaders = $84e5673159d64e64$var$headers.filter(function(header) {
        return !targetElements.find(function(element) {
            return element === header;
        });
    });
    $84e5673159d64e64$var$headers = (0, $7f330cb05a0d35f2$export$71511d61b312f219)(dedupedHeaders).concat((0, $7f330cb05a0d35f2$export$71511d61b312f219)(targetElements));
    if ($84e5673159d64e64$var$headers.length === 0) return;
    $84e5673159d64e64$var$headers.forEach(function(header) {
        return new $84e5673159d64e64$export$71ba45104f4e8b56(header);
    });
};





var $5920e0b334d1f5a6$var$capturedElements = [];
var $5920e0b334d1f5a6$var$scrollMarkers = [];
var $5920e0b334d1f5a6$var$ScrollMarkers = /*#__PURE__*/ function() {
    "use strict";
    function ScrollMarkers(element) {
        (0, $14f878af2f96d88a$export$71511d61b312f219)(this, ScrollMarkers);
        this.element = element;
        this.scrollContainer = this.element.parentElement;
        this.markers = [];
        this.init();
    }
    (0, $98bc9ed74ab4b61d$export$71511d61b312f219)(ScrollMarkers, [
        {
            key: "init",
            value: function init1() {
                console.log('init');
                var elementPosition = this.element.style.position;
                if (elementPosition !== 'absolute' || elementPosition !== 'relative') this.element.style.position = 'relative';
                this.drawOverflowMarkers();
                this.initScrollObserver();
            }
        },
        {
            key: "drawOverflowMarkers",
            value: function drawOverflowMarkers() {
                var startMarker = document.createElement('div');
                var startMarkerStyles = {
                    display: 'flex',
                    order: -1,
                    width: '1px',
                    height: '1px',
                    minHeight: '1px',
                    visibility: 'hidden'
                };
                var endMarker = document.createElement('div');
                var endMarkerStyles = {
                    display: 'flex',
                    order: 100,
                    width: '1px',
                    height: '1px',
                    minHeight: '1px',
                    visibility: 'hidden'
                };
                endMarker.setAttribute('data-marker-position', 'end');
                startMarker.setAttribute('data-marker-position', 'start');
                Object.assign(startMarker.style, startMarkerStyles);
                Object.assign(endMarker.style, endMarkerStyles);
                this.element.appendChild(startMarker);
                this.element.appendChild(endMarker);
                this.markers.push(startMarker, endMarker);
            }
        },
        {
            key: "initScrollObserver",
            value: function initScrollObserver() {
                var _this = this;
                var options = {
                    threshhold: 1
                };
                var observerHandler = function(entries, observer) {
                    entries.forEach(function(entry) {
                        var markerPosition = entry.target.dataset.markerPosition;
                        var dataAttributeName = "data-".concat(markerPosition, "-marker");
                        if (entry.isIntersecting) _this.scrollContainer.setAttribute(dataAttributeName, 'hide');
                        else _this.scrollContainer.setAttribute(dataAttributeName, 'show');
                    });
                };
                var observer = new IntersectionObserver(observerHandler, options);
                this.markers.forEach(function(marker) {
                    observer.observe(marker);
                });
            }
        }
    ]);
    return ScrollMarkers;
}();
var $5920e0b334d1f5a6$export$80b16cefbfd605c9 = function(element) {
    $5920e0b334d1f5a6$var$capturedElements.push(element);
    $5920e0b334d1f5a6$var$scrollMarkers.push(new $5920e0b334d1f5a6$var$ScrollMarkers(element));
};
var $5920e0b334d1f5a6$export$2e2bcd8739ae039 = init = function() {
    var target = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : document;
    if (typeof jweather === 'undefined') return;
    var targetElements = (0, $7f330cb05a0d35f2$export$71511d61b312f219)(target.querySelectorAll('[data-scroll-markers]'));
    var dedupedTargetElements = targetElements.filter(function(targetElement) {
        return !$5920e0b334d1f5a6$var$capturedElements.find(function(capturedElement) {
            return targetElement === capturedElement;
        });
    });
    if (dedupedTargetElements.length === 0) return;
    dedupedTargetElements.forEach(function(element) {
        $5920e0b334d1f5a6$export$80b16cefbfd605c9(element);
    });
};



var $94878cc59e5a3d03$var$intersectionHandler = function(entries) {
    entries.forEach(function(entry) {
        entry.target.classList.toggle("is-pinned", entry.intersectionRatio < 1);
    });
};
var $94878cc59e5a3d03$var$createObserver = function(stickyElement) {
    var stickyTop = parseInt(getComputedStyle(stickyElement).top) + 1;
    var observer = new IntersectionObserver($94878cc59e5a3d03$var$intersectionHandler, {
        rootMargin: "-".concat(stickyTop, "px 0px 0px 0px"),
        threshold: 1
    });
    observer.observe(stickyElement);
};
var $94878cc59e5a3d03$export$2e2bcd8739ae039 = init = function() {
    var stickyElements = (0, $7f330cb05a0d35f2$export$71511d61b312f219)(document.querySelectorAll('.jwc-sticky'));
    if (stickyElements.length === 0) return;
    stickyElements.forEach(function(element) {
        return $94878cc59e5a3d03$var$createObserver(element);
    });
};







var $a589739b679d8eff$var$capturedElements = [];
var $a589739b679d8eff$var$tabLists = [];
var $a589739b679d8eff$var$TabList = function TabList(element, settings) {
    "use strict";
    var _this = this;
    (0, $14f878af2f96d88a$export$71511d61b312f219)(this, TabList);
    (0, $a1751332bdbcd2df$export$71511d61b312f219)(this, "init", function() {
        _this.getTabPanels();
        _this.setInitialState();
        _this.tabs.forEach(function(tab) {
            return tab.addEventListener('click', _this.clickHandler);
        });
        _this.tabs.forEach(function(tab) {
            return tab.addEventListener('keydown', _this.keydownHandler);
        });
    });
    (0, $a1751332bdbcd2df$export$71511d61b312f219)(this, "setSelectedTab", function(element) {
        _this.tabs.forEach(function(tab) {
            var tabHref = tab.getAttribute('href');
            var tabPanel = _this.tabPanels.filter(function(tabPanel) {
                return "#".concat(tabPanel.id) === tabHref;
            })[0];
            if (element === tab) {
                tab.removeAttribute('tabindex');
                tab.setAttribute('aria-selected', 'true');
                _this.setTabIndicatorVariables(tab);
                if (typeof _this.selectCallback === 'function') _this.selectCallback(tab, tabPanel);
            } else {
                tab.setAttribute('tabindex', '-1');
                tab.setAttribute('aria-selected', 'false');
                tabPanel.removeAttribute('data-state');
            }
        });
    });
    (0, $a1751332bdbcd2df$export$71511d61b312f219)(this, "setTabPanelIndexes", function() {
        _this.tabPanels.forEach(function(tabPanel) {
            var focusableElements = tabPanel.querySelectorAll((0, (/*@__PURE__*/$parcel$interopDefault($ea88dda94eed7848$exports))).join(', ')).length;
            focusableElements ? tabPanel.setAttribute('tabindex', '-1') : tabPanel.setAttribute('tabindex', '0');
        });
    });
    (0, $a1751332bdbcd2df$export$71511d61b312f219)(this, "getTabPanels", function() {
        _this.tabPanels = _this.tabs.map(function(tab) {
            return document.querySelector(tab.getAttribute('href'));
        });
    });
    (0, $a1751332bdbcd2df$export$71511d61b312f219)(this, "clickHandler", function(e) {
        _this.setSelectedTab(e.target);
    });
    (0, $a1751332bdbcd2df$export$71511d61b312f219)(this, "keydownHandler", function(e) {
        var firstTab = _this.tabs[0];
        var lastTab = _this.tabs[_this.tabs.length - 1];
        var currentTabIndex = _this.tabs.indexOf(e.target);
        if ((e.keyCode || e.which) === (0, $5b60cdba3ee79e87$export$2e2bcd8739ae039).SPACE) {
            _this.setSelectedTab(e.target);
            e.target.click();
        } else if ((e.keyCode || e.which) === (0, $5b60cdba3ee79e87$export$2e2bcd8739ae039).LEFT || (e.keyCode || e.which) === (0, $5b60cdba3ee79e87$export$2e2bcd8739ae039).UP) {
            if (e.target === firstTab) {
                e.preventDefault();
                lastTab.focus();
            } else {
                e.preventDefault();
                var prevTabIndex = currentTabIndex - 1;
                _this.tabs[prevTabIndex].focus();
            }
        } else if ((e.keyCode || e.which) === (0, $5b60cdba3ee79e87$export$2e2bcd8739ae039).RIGHT || (e.keyCode || e.which) === (0, $5b60cdba3ee79e87$export$2e2bcd8739ae039).DOWN) {
            if (e.target === lastTab) {
                e.preventDefault();
                firstTab.focus();
            } else {
                e.preventDefault();
                var nextTabIndex = currentTabIndex + 1;
                _this.tabs[nextTabIndex].focus();
            }
        }
    });
    (0, $a1751332bdbcd2df$export$71511d61b312f219)(this, "activateFirstPanel", function() {
        _this.tabs[0].setAttribute('tabindex', '0');
        _this.tabs[0].setAttribute('aria-selected', 'true');
        _this.tabPanels[0].setAttribute('data-state', 'open');
        _this.setTabIndicatorVariables(_this.tabs[0]);
    });
    (0, $a1751332bdbcd2df$export$71511d61b312f219)(this, "setInitialState", function() {
        _this.tabs.forEach(function(tab) {
            tab.setAttribute('tabindex', '-1');
            tab.setAttribute('aria-selected', 'false');
        });
        var urlPanelHash = new URL(window.location.href).hash;
        if (urlPanelHash) {
            var panelTab = _this.tabs.filter(function(tab) {
                return tab.getAttribute('href') === urlPanelHash;
            });
            if (panelTab.length > 0) {
                panelTab[0].setAttribute('aria-selected', 'true');
                panelTab[0].removeAttribute('tabindex');
                _this.setTabIndicatorVariables(panelTab[0]);
            } else _this.activateFirstPanel();
        } else _this.activateFirstPanel();
        _this.setTabPanelIndexes();
    });
    (0, $a1751332bdbcd2df$export$71511d61b312f219)(this, "setTabIndicatorVariables", function(tab) {
        var tabListRect = _this.tablist.getBoundingClientRect();
        var tabRect = tab.getBoundingClientRect();
        var leftDelta = tabRect.left - tabListRect.left;
        document.documentElement.style.setProperty('--nav-tab-pos-left', leftDelta + "px");
        document.documentElement.style.setProperty('--nav-tab-width', tabRect.width + "px");
    });
    this.tablist = element;
    this.tabs = (0, $7f330cb05a0d35f2$export$71511d61b312f219)(element.querySelectorAll("a"));
    this.selectCallback = settings.selectCallback || null;
    this.init();
};
var $a589739b679d8eff$export$1a383feecf645243 = function(element, settings) {
    $a589739b679d8eff$var$capturedElements.push(element);
    $a589739b679d8eff$var$tabLists.push(new $a589739b679d8eff$var$TabList(element, settings));
};
var $a589739b679d8eff$export$2e2bcd8739ae039 = init = function() {
    var target = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : document;
    var targetElements = (0, $7f330cb05a0d35f2$export$71511d61b312f219)(target.querySelectorAll('[data-tablist]'));
    var dedupedTargetElements = targetElements.filter(function(targetElement) {
        return !$a589739b679d8eff$var$capturedElements.find(function(capturedElement) {
            return targetElement === capturedElement;
        });
    });
    if (dedupedTargetElements.length === 0) return;
    dedupedTargetElements.forEach(function(element) {
        $a589739b679d8eff$export$1a383feecf645243(element);
    });
};





var $ac84f38ce7b35c44$var$capturedElements = [];
var $ac84f38ce7b35c44$var$toggleTips = [];
var $ac84f38ce7b35c44$var$ToggleTip = function ToggleTip(element) {
    "use strict";
    var _this = this;
    (0, $14f878af2f96d88a$export$71511d61b312f219)(this, ToggleTip);
    (0, $a1751332bdbcd2df$export$71511d61b312f219)(this, "buildToggleTip", function() {
        _this.controller.classList.add('jwc-toggletip');
        _this.controller.setAttribute('data-state', 'closed');
        // liveRegion is for accessibility
        _this.liveRegion = document.createElement('span');
        _this.liveRegion.classList.add('jwc-toggletip-container');
        _this.liveRegion.setAttribute('role', 'status');
        _this.controller.appendChild(_this.liveRegion);
        _this.controller.addEventListener('click', _this.clickHandler);
        _this.controller.addEventListener('blur', function(e) {
            _this.clearContent();
        });
        _this.controller.addEventListener('keydown', function(e) {
            if ((e.keyCode || e.which) === 27) _this.clearContent();
        });
    });
    (0, $a1751332bdbcd2df$export$71511d61b312f219)(this, "getContent", function() {
        var contentContainer = _this.controller.querySelector('[data-toggletip-text]');
        var content = contentContainer !== null ? contentContainer.innerHTML : _this.controller.innerHTML;
        if (contentContainer) contentContainer.parentElement.removeChild(contentContainer);
        return content;
    });
    (0, $a1751332bdbcd2df$export$71511d61b312f219)(this, "clickHandler", function(e) {
        e.preventDefault();
        _this.addContent();
        document.addEventListener('click', _this.bodyClickHandler, {
            once: true
        });
    });
    (0, $a1751332bdbcd2df$export$71511d61b312f219)(this, "bodyClickHandler", function(e) {
        if (_this.controller !== e.target) _this.clearContent();
    });
    (0, $a1751332bdbcd2df$export$71511d61b312f219)(this, "addContent", function() {
        window.setTimeout(function() {
            _this.liveRegion.innerHTML = _this.content;
            _this.controller.setAttribute('data-state', 'open');
        });
    });
    (0, $a1751332bdbcd2df$export$71511d61b312f219)(this, "clearContent", function(e) {
        _this.liveRegion.innerHTML = '';
        _this.controller.setAttribute('data-state', 'closed');
    });
    this.controller = element;
    this.content = this.getContent();
    this.buildToggleTip();
};
var $ac84f38ce7b35c44$export$e168f44387db4a77 = function(element) {
    $ac84f38ce7b35c44$var$capturedElements.push(element);
    $ac84f38ce7b35c44$var$toggleTips.push(new $ac84f38ce7b35c44$var$ToggleTip(element));
};
var $ac84f38ce7b35c44$export$2e2bcd8739ae039 = init = function() {
    var target = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : document;
    var targetElements = (0, $7f330cb05a0d35f2$export$71511d61b312f219)(target.querySelectorAll('[data-toggletip]'));
    var dedupedTargetElements = targetElements.filter(function(targetElement) {
        return !$ac84f38ce7b35c44$var$capturedElements.find(function(capturedElement) {
            return targetElement === capturedElement;
        });
    });
    if (dedupedTargetElements.length === 0) return;
    dedupedTargetElements.forEach(function(element) {
        $ac84f38ce7b35c44$var$capturedElements.push(element);
        $ac84f38ce7b35c44$var$toggleTips.push(new $ac84f38ce7b35c44$var$ToggleTip(element));
    });
};




var $dbdb961786fea93c$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    "use strict";
    function EventBus() {
        (0, $14f878af2f96d88a$export$71511d61b312f219)(this, EventBus);
        this.bus = document.createElement('bus');
    }
    (0, $98bc9ed74ab4b61d$export$71511d61b312f219)(EventBus, [
        {
            key: "addEventListener",
            value: function addEventListener(event, callback) {
                this.bus.addEventListener(event, callback);
            }
        },
        {
            key: "removeEventListener",
            value: function removeEventListener(event, callback) {
                this.bus.removeEventListener(event, callback);
            }
        },
        {
            key: "dispatchEvent",
            value: function dispatchEvent(event) {
                var detail = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
                this.bus.dispatchEvent(new CustomEvent(event, {
                    detail: detail
                }));
            }
        }
    ]);
    return EventBus;
}();


window.$EventBus = new (0, $dbdb961786fea93c$export$2e2bcd8739ae039);
window.jwc = {
    toggleTips: {
        init: function(target) {
            return (0, $ac84f38ce7b35c44$export$2e2bcd8739ae039)(target);
        },
        add: function(element) {
            return (0, $ac84f38ce7b35c44$export$e168f44387db4a77)(element);
        }
    },
    popUps: {
        init: function(target) {
            return (0, $90f13c4656c15d55$export$2e2bcd8739ae039)(target);
        },
        add: function(target) {
            return (0, $90f13c4656c15d55$export$b68b5509ce5f1141)(target);
        }
    },
    headerDisclosures: {
        init: function(target) {
            return (0, $84e5673159d64e64$export$2e2bcd8739ae039)(target);
        }
    },
    modals: {
        init: function(target) {
            return (0, $c69b09cc0cfb1962$export$2e2bcd8739ae039)(target);
        },
        add: function(modal, opener, settings) {
            return (0, $c69b09cc0cfb1962$export$89892de00be9f648)(modal, opener, settings);
        }
    },
    tabs: {
        init: function(target) {
            return (0, $a589739b679d8eff$export$2e2bcd8739ae039)(target);
        },
        add: function(element, settings) {
            return (0, $a589739b679d8eff$export$1a383feecf645243)(element, settings);
        }
    },
    scrollMarkers: {
        init: function(target) {
            return (0, $5920e0b334d1f5a6$export$2e2bcd8739ae039)(target);
        },
        add: function(element, settings) {
            return (0, $5920e0b334d1f5a6$export$80b16cefbfd605c9)(element, settings);
        }
    }
};
window.addEventListener('DOMContentLoaded', function() {
    (0, $c69b09cc0cfb1962$export$2e2bcd8739ae039)();
    (0, $90f13c4656c15d55$export$2e2bcd8739ae039)();
    (0, $84e5673159d64e64$export$2e2bcd8739ae039)();
    (0, $5920e0b334d1f5a6$export$2e2bcd8739ae039)();
    (0, $94878cc59e5a3d03$export$2e2bcd8739ae039)();
    (0, $a589739b679d8eff$export$2e2bcd8739ae039)();
    (0, $ac84f38ce7b35c44$export$2e2bcd8739ae039)();
    (0, $62682efe9afeb191$export$2e2bcd8739ae039)();
    window.jwc.toaster = new (0, $287db0316ca2c5f6$export$2e2bcd8739ae039)();
});

})();
//# sourceMappingURL=jweather-core.js.map
